import api from './api';

/**
 * System Themes API Service
 * Handles theme operations (admin managed, system-wide)
 */

/**
 * Get the active theme (PUBLIC - no auth required)
 * @returns {Promise<Object>} Active theme
 */
export async function getActiveTheme() {
  const res = await api.get('/themes/active');
  return res.data;
}

/**
 * Get all themes (ADMIN only)
 * @returns {Promise<Array>} Array of all themes
 */
export async function getAllThemes() {
  const res = await api.get('/themes');
  return res.data;
}

/**
 * Create a new custom theme (ADMIN only)
 * @param {Object} themeData - Theme data (name, colors, gradients)
 * @returns {Promise<Object>} Created theme
 */
export async function createTheme(themeData) {
  const res = await api.post('/themes', themeData);
  return res.data;
}

/**
 * Update an existing theme (ADMIN only)
 * @param {number} id - Theme ID
 * @param {Object} themeData - Updated theme data
 * @returns {Promise<Object>} Updated theme
 */
export async function updateTheme(id, themeData) {
  const res = await api.put(`/themes/${id}`, themeData);
  return res.data;
}

/**
 * Activate a theme (ADMIN only)
 * @param {number} id - Theme ID to activate
 * @returns {Promise<Object>} Response with activated theme
 */
export async function activateTheme(id) {
  const res = await api.put(`/themes/${id}/activate`);
  return res.data;
}

/**
 * Delete a theme (ADMIN only)
 * @param {number} id - Theme ID
 * @returns {Promise<Object>} Response with success message
 */
export async function deleteTheme(id) {
  const res = await api.delete(`/themes/${id}`);
  return res.data;
}

